export default "__VITE_ASSET__BO_EHwGN__"